import React from 'react';
import styles from './ActionLoader.module.css';
import useTheme from 'config/useTheme';

const ActionLoader = ({ text }) => {
    const { dark } = useTheme();
    return (
        <div className={`${styles.action_loader} ${dark ? styles.dark : ''}`}>
            <div className={styles.action_loader_container}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32"
                >
                    <path fill="#A7D8EB" d="M0 0h32v32H0z"></path>
                </svg>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    fill="none"
                    viewBox="0 0 46 46"
                >
                    <path
                        fill="url(#paint0_radial_289_1186)"
                        d="M23 0h32v32H23z"
                        transform="rotate(45 23 0)"
                    ></path>
                    <defs>
                        <radialGradient
                            id="paint0_radial_289_1186"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientTransform="matrix(0 32 -32 0 39 0)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#4FB1D8"></stop>
                            <stop offset="0.5" stopColor="#239DCE"></stop>
                            <stop offset="1" stopColor="#1C7EA5"></stop>
                        </radialGradient>
                    </defs>
                </svg>
            </div>
            {text && <span>{text}</span>}
        </div>
    )
}

export default ActionLoader;